var map = {
	"./contract_black.png": "5ba0",
	"./contract_blue.png": "92e6",
	"./contract_green.png": "b215",
	"./contract_orange.png": "96e7",
	"./contract_pink.png": "2fca",
	"./contract_purple.png": "7d61",
	"./contract_red.png": "c395"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "47a0";